import { Link } from 'react-router-dom'
import { f2 } from '../copyFlow2'
import { Compass, Heart, List } from './icons'
import { usePlanNav } from './planNav'

/** The phone toolbar (Astra #5 shell, Flow 2 places): 56px plus the bottom safe area; the page reserves that plus 16px. */
export const TOOLBAR = 'calc(56px + env(safe-area-inset-bottom))'

const ICONS = [Compass, Heart, List]

/** Phone and tablet tab bar (Plan v3): Browse, Saved, Itineraries, always on screen and solid (nothing shows through). */
export function TabBar() {
  const items = usePlanNav().slice(0, 3)
  return (
    <nav aria-label={f2('nav.browse')} data-review-id="tab-bar" className="fixed inset-x-0 bottom-0 z-30 border-t border-line bg-bg pb-[env(safe-area-inset-bottom)] lg:hidden">
      <div className="mx-auto grid h-14 w-full max-w-md grid-cols-3 px-1">
        {items.map(({ to, label, on, count }, i) => {
          const Icon = ICONS[i]
          return (
            <Link key={label} to={to} aria-current={on ? 'page' : undefined} data-count={count ?? undefined}
              className={`press flex min-w-0 flex-col items-center justify-center gap-0.5 rounded-xl active:bg-sunk/70 ${on ? 'text-accent-ink' : 'text-ink'}`}>
              <Icon size={20} strokeWidth={on ? 2.4 : 2} />
              <span className={`max-w-full truncate px-0.5 text-[11px] leading-4 ${on ? 'font-semibold' : 'font-medium'}`}>{label}</span>
            </Link>
          )
        })}
      </div>
    </nav>
  )
}
